<div class="flex justify-between items-end gap-4 my-4 pl-4">
  <div class="flex gap-4 flex-wrap">
    <div class="flex gap-4 items-center">
      <div class="text-base font-semibold" data-test-id="select-queue-header">
        {{ queueTypes.length > 1 ? 'Select Queue:' : 'Queue' }}
      </div>
      @if (queueTypes.length > 1) {
        <p-select
          placeholder="Select"
          appendTo="body"
          data-test-id="select-queue-dropdown"
          [options]="queueTypes"
          [(ngModel)]="selectedQueueType"
          (onChange)="setActiveQueueType($event.value)"
          />
      }
    </div>

    <ng-content select="[queue-action]" />
  </div>

  <div class="flex grow shrink-0 justify-end">
    <button
      pButton
      type="button"
      severity="secondary"
      label="Reload Queue"
      icon="pi pi-refresh"
      class="mr-2"
      data-test-id="reload-queue-button"
      (click)="resetSelection()">
    </button>
    <button
      pButton
      type="button"
      severity="secondary"
      label="Clear All Filters"
      icon="pi pi-filter-slash"
      data-test-id="clear-filters-button"
      (click)="clearAll()">
    </button>

    <ng-content select="[additional-action]" />
  </div>
</div>
